import { Vendor } from "./index";

export class TemplateVendorAccountCategory {
    id: number;
    templateId: number;
    vendorId: number;
    acctCategoryId: number;
    vendor: Vendor;
}
